import { CardDocumentsDataProps } from '@/components/card-documents'
import { LogisticShipmentProps } from '@/types'

const documentsList: Record<
  string,
  { fileTranslationId: string; file: keyof LogisticShipmentProps }[]
> = {
  internal: [
    {
      // Factura de transporte
      fileTranslationId: 'cardOrderLogisticDocumentsInvoiceLabel',
      file: 'shipmentInvoice',
    },
    {
      // Remisión
      fileTranslationId: 'cardOrderLogisticDocumentsRemision',
      file: 'deliveryList',
    },
    {
      // Packing list
      fileTranslationId: 'cardOrderLogisticDocumentsPackingList',
      file: 'packingList',
    },
    {
      // Bill of landing
      fileTranslationId: 'cardOrderLogisticDocumentsBillOfLanding',
      file: 'billOfLanding',
    },
    {
      // Salida de almacén
      fileTranslationId: 'cardOrderLogisticDocumentsWarehouseExit',
      file: 'warehouseExit',
    },
    {
      // Combrobante de entrega
      fileTranslationId: 'cardOrderLogisticDocumentsShipmentReceipt',
      file: 'shipmentReceipt',
    },
  ],
  external: [
    {
      // COO - Certificado de origen
      fileTranslationId: 'cardOrderLogisticDocumentsOriginCertificateLabel',
      file: 'originCertificate',
    },
    {
      // COA - Certificado de calidad
      fileTranslationId: 'cardOrderLogisticDocumentsCustomsCertificateLabel',
      file: 'customsCertificate',
    },
    {
      // Evidencia de entrega
      fileTranslationId: 'cardOrderLogisticDocumentsDeliveryProof',
      file: 'proofOfDelivery',
    },
  ],
}

export const getInternalLogisticDocuments = (
  t: (key: string) => string,
  shipment?: LogisticShipmentProps,
) => {
  const internalDocuments: CardDocumentsDataProps = {
    title: t('cardOrderLogisticDocumentsInternalLabel'),
    data: [],
  }

  documentsList.internal.forEach((document) => {
    if (shipment?.[document.file]) {
      internalDocuments.data?.push({
        title: t(document.fileTranslationId),
        file: shipment[document.file] as string,
      })
    }
  })

  return internalDocuments
}

export const getExternalLogisticDocuments = (
  t: (key: string) => string,
  shipment?: LogisticShipmentProps,
) => {
  const externalDocuments: CardDocumentsDataProps = {
    title: t('cardOrderLogisticDocumentsExternalLabel'),
    data: [],
  }

  documentsList.external.forEach((document) => {
    if (shipment?.[document.file]) {
      externalDocuments.data?.push({
        title: t(document.fileTranslationId),
        file: shipment[document.file] as string,
      })
    }
  })

  return externalDocuments
}

export const getLogisticDocuments = (
  t: (key: string) => string,
  shipment?: LogisticShipmentProps,
): CardDocumentsDataProps[] => {
  if (!shipment) return []

  const internalDocuments: CardDocumentsDataProps =
    getInternalLogisticDocuments(t, shipment)
  const externalDocuments: CardDocumentsDataProps =
    getExternalLogisticDocuments(t, shipment)

  const result = []

  if (internalDocuments?.data && internalDocuments?.data?.length > 0)
    result.push(internalDocuments)
  if (externalDocuments?.data && externalDocuments?.data?.length > 0)
    result.push(externalDocuments)

  return result
}
